<template>
  <div>
    <div class="mb-4">
      <label for="Sender" class="font-weight-bold">
        {{ $t('automation.sms.content.select-1.value') }}
      </label>
      <multiselect
        class="no-close border-gray-300 rounded select"
        v-model="senderSelect"
        custom
        :multiple="false"
        :allow-empty="false"
        :loading="isLoadingSenders"
        :disabled="isLoadingSenders"
        :custom-label="(option) => option.label"
        :options="senderSelectOptions"
        :placeholder="$t(`automation.sms.content.select.one`)"
        @input="selectSender"
      />
    </div>
    <div class="mb-4">
      <label for="Template" class="font-weight-bold">
        {{ $t('automation.sms.content.select-3.value') }}
      </label>
      <multiselect
        class="no-close border-gray-300 rounded select"
        v-model="templateSelect"
        custom
        :multiple="false"
        :allow-empty="false"
        :loading="isLoadingTemplates"
        :disabled="isLoadingTemplates"
        :custom-label="(option) => option.label"
        :options="templateSelectOptions"
        :placeholder="$t(`automation.sms.content.select.one`)"
        @input="selectTemplate"
      />
    </div>
  </div>
</template>

<script>
import { FIELD_TYPE } from '../constants'
export default {
  name: 'AutomationSMSContentTemplate',
  props: {
    senderSelectOptions: {
      type: Array,
      default: () => [],
    },
    isLoadingSenders: {
      type: Boolean,
      default: false,
    },
    templateSelectOptions: {
      type: Array,
      default: () => [],
    },
    isLoadingTemplates: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      senderSelect: undefined,
      templateSelect: undefined,
    }
  },
  mounted() {
    if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.senderId) {
      this.senderSelect = {
        value: this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.senderId,
        label: this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.senderName,
      }
    }
    if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.templateId) {
      let template = this.templateSelectOptions.find(
        (el) => el.value == this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.templateId,
      )
      this.templateSelect = {
        value: this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.templateId,
      }
    }
  },
  methods: {
    selectSender() {
      let senderId = {
        property: 'senderId',
        value: this.senderSelect.value,
        type: FIELD_TYPE.STEP,
      }
      this.$emit('update-field', senderId)

      let senderName = {
        property: 'senderName',
        value: this.senderSelect.label,
        type: FIELD_TYPE.STEP,
      }
      this.$emit('update-field', senderName)
    },

    selectTemplate() {
      let templateId = {
        property: 'templateId',
        value: this.templateSelect.value,
        type: FIELD_TYPE.STEP,
      }
      this.$emit('update-field', templateId)
    },
  },
}
</script>
